import PropTypes from "prop-types";
import styled from "styled-components";

function UserSettingsShell({ sidebar, children }) {
	return (
		<SettingsWrapper>
			{sidebar}
			<SettingsContentPanel>{children}</SettingsContentPanel>
		</SettingsWrapper>
	);
}

UserSettingsShell.propTypes = {
	sidebar: PropTypes.node.isRequired,
	children: PropTypes.node.isRequired,
};

export default UserSettingsShell;

const SettingsWrapper = styled.div`
	display: flex;
	align-items: stretch;
	max-width: 1400px;
	width: 100%;
	min-height: 520px;

	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		flex-direction: column;
	}
`;

const SettingsContentPanel = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
`;
